import script from "./ChatPivotTableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPivotTableCard.vue?vue&type=script&setup=true&lang=js"

import "./ChatPivotTableCard.vue?vue&type=style&index=0&id=df12e94a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df12e94a"]])

export default __exports__